var base = require("./base");
const debounce = require("lodash/debounce");

var slickCarousel = require("../components/slickCarousel");
var zoomModal = require("../components/zoomModal");
var commonFeature = require("../components/commonFeature");

var $window = $(window);

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements() {
    var enable = $(".product-availability").toArray().every(function (item) {
        return $(item).data("available") && $(item).data("ready-to-order");
    });

    $("button.add-to-cart-global").attr("disabled", !enable);
    if (!enable) {
        $(".prices-add-to-cart-actions").addClass("disabled-actions");
    } else {
        $(".prices-add-to-cart-actions").removeClass("disabled-actions");
    }
}

function initZoomModal() {
    var $mainSliders = $("[id^=pdp-main-slider]");
    $mainSliders.each(function () {
        zoomModal.init($(this));
    });
}

function initReadMoreDesc() {
    var description = $(".description-and-detail .description .content");

    description.each(function () {
        var $this = $(this);
        var $descriptionInner = $this.closest(".description-inner");
        var $readMoreBtn = $this.closest(".description").find(".button-read-more");
        var textHeight = $this.height();
        var containerHeight = $descriptionInner.height();
        var descriptionWasExpanded = $descriptionInner.hasClass("expanded");

        $readMoreBtn.addClass("d-none");
        $descriptionInner.removeClass("expanded");

        if (textHeight > containerHeight || descriptionWasExpanded) {
            $readMoreBtn.removeClass("d-none");
        }
    });
}

function handleStickyBuyBar() {
    var $stickyBar = $(".sticky-buy-bar");
    var $addToCartBtn = $(".sidebar-section .prices-add-to-cart-actions .cart-and-ipay");
    var $helpButton = $(".embeddedServiceHelpButton .helpButton");

    if ($addToCartBtn.length && commonFeature.isInViewport($addToCartBtn, true)) {
        $stickyBar.removeClass("fixedbottom");
        $helpButton.removeClass("fixedbottom");
    } else {
        $stickyBar.addClass("fixedbottom");
        $(function () {
            $helpButton.addClass("fixedbottom");
        });
    }
}

function handleStickyDetailsHeight() {
    if (commonFeature.isBreakpoint(">=md")) {
        var sidebarHeight = $(".sidebar-section").find(".attributes.accordion").height();
        var carouselSectionOffset =  $(".carousel-section").offset();
        var stickyDetailsDesktopOffset = $(".sticky-details-desktop").offset();
        var stickyDetailsDesktopHeight = $(".sticky-details-desktop").height();
        var carouselHeight = (stickyDetailsDesktopOffset.top - carouselSectionOffset.top) + stickyDetailsDesktopHeight;
        // Ensures carousel is always taller than sidebar
        var height = carouselHeight < sidebarHeight * 1.5 ? sidebarHeight * 1.5 : carouselHeight;
        $(".sticky-details-desktop")
            .closest(".carousel-section")
            .css("height", height);
    } else {
        $(".sticky-details-desktop")
            .closest(".carousel-section")
            .css("height", "auto");
    }
}

function handlePDPImagesResize() {
    var imagesContainer = document.querySelector(".pdp-images-main-container");

    if (!imagesContainer) {
        imagesContainer = document.querySelector(".primary-images-pdp");
    }

    if (imagesContainer) {
        var observer = new ResizeObserver(function () {
            handleStickyDetailsHeight();
        });
        observer.observe(imagesContainer);
    }
}

module.exports = {
    updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements,

    availability: base.availability,

    addToCart: base.addToCart,

    updateAttributesAndDetails: function () {
        $("body").on("product:statusUpdate", function (e, response) {
            
            var $productContainer = response.$productContainer;
            var data = response.product;
            var productDetailsDesktop = $productContainer.find(".description-and-detail .product-attributes")[0];
            var productDetailsMobile = $productContainer.find(".description-and-detail .product-attributes")[1];

            $(productDetailsDesktop).empty().html(data.attributesHtml);
            $(productDetailsMobile).empty().html(data.attributesHtml);

            var $mainAttributes = $productContainer.find(".main-attributes");
            var dimensions;

            for (var i = 0; i < data.attributes.length; i++) {
                if (data.attributes[i].ID === "dimensions") {
                    dimensions = data.attributes[i];
                    break;
                }
            }

            if (dimensions && $mainAttributes.length) {
                for (var j = 0; j < dimensions.attributes.length; j++) {
                    var currentAttribute = dimensions.attributes[j];
                    var $attribute = $mainAttributes.find(".attribute-values[data-attribute='" + currentAttribute.label + "']");                    
                    $attribute.find(".attribute-value").text(currentAttribute.value);
                }
            }

            if ($(productDetailsMobile).find("#heading-specifications-desktop").length) {
                var $specsMobile = $(productDetailsMobile).find("#heading-specifications-desktop").closest(".card");
                $specsMobile.find("#heading-specifications-desktop").attr("id", "heading-specifications-mobile");
                $specsMobile.find("button").attr("aria-controls", "collapse-specifications-mobile");
                $specsMobile.find("button").attr("data-target", "#collapse-specifications-mobile");
                $specsMobile.find(".collapse").attr("id", "collapse-specifications-mobile");
                $specsMobile.find(".collapse").attr("aria-labelledby", "heading-specifications-mobile");
                $specsMobile.find(".collapse").attr("data-parent", "#specificationsAccordion-mobile");
            }

            if (data.longDescription || data.shortDescription) {
                $productContainer.find(".description-and-detail .description")
                    .removeClass("hidden-xl-down");
                $productContainer.find(".description-and-detail .description .content")
                    .empty()
                    .html(data.longDescription ? data.longDescription : data.shortDescription);
                initReadMoreDesc();
            } else {
                $productContainer.find(".description-and-detail .description")
                    .addClass("hidden-xl-down");
            }

            if (data.deliveryMessage) {
                $productContainer.find(".delivery-message").text(data.deliveryMessage);
            } else {
                $productContainer.find(".delivery-message").empty();
            }

            if (data.DeliveryInformation) {
                var $contentAssetContainer = $productContainer.find("#collapse-delivery-information-desktop .content-asset, #collapse-delivery-information-mobile .content-asset");
                
                if ($contentAssetContainer.length) {
                    $contentAssetContainer.html(data.DeliveryInformation);
                } else {
                    $productContainer.find("#collapse-delivery-information-desktop .card-body, #collapse-delivery-information-mobile .card-body").html(data.DeliveryInformation);
                }
            }
        });
    },

    showSpinner: function () {
        $("body").on("product:beforeAddToCart product:beforeAttributeSelect", function () {
            $.spinner().start();
        });
    },
    updateAttribute: function () {
        $("body").on("product:afterAttributeSelect", function (e, response) {
            if ($(".product-detail>.bundle-items").length) {
                response.container.data("pid", response.data.product.id);
                response.container.find(".product-id").text(response.data.product.id);
            } else if ($(".product-set-detail").eq(0)) {
                response.container.data("pid", response.data.product.id);
                response.container.find(".product-id").text(response.data.product.id);
            } else {
                $(".product-id").text(response.data.product.id);
                $(".product-detail:not('.bundle-item')").data("pid", response.data.product.id);
            }
        });
    },
    updateAddToCart: function () {
        $("body").on("product:updateAddToCart", function (e, response) {
            // update local add to cart (for sets)
            $("button.add-to-cart", response.$productContainer).attr("disabled",
                (!response.product.readyToOrder || !response.product.available || !response.product.SellOnWeb));

            if (!response.product.readyToOrder || !response.product.available || !response.product.SellOnWeb) {
                $(".prices-add-to-cart-actions", response.$productContainer).addClass("disabled-actions");
            } else {
                $(".prices-add-to-cart-actions", response.$productContainer).removeClass("disabled-actions");
            }
            updateAddToCartEnableDisableOtherElements();
        });
    },
    updateAvailability: function () {
        $("body").on("product:updateAvailability", function (e, response) {
            $("div.availability", response.$productContainer)
                .data("ready-to-order", response.product.readyToOrder)
                .data("available", response.product.available);

            $(".availability-msg", response.$productContainer)
                .empty().html(response.message);

            if ($(".global-availability").length) {
                var allAvailable = $(".product-availability").toArray()
                    .every(function (item) { return $(item).data("available"); });

                var allReady = $(".product-availability").toArray()
                    .every(function (item) { return $(item).data("ready-to-order"); });

                $(".global-availability")
                    .data("ready-to-order", allReady)
                    .data("available", allAvailable);

                $(".global-availability .availability-msg").empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },

    readMoreDescription: function () {
        $("body").on("click", ".button-read-more", function () {
            var $this = $(this);
            var $descriptionInner = $this.closest(".description").find(".description-inner");

            $this.addClass("d-none");
            $descriptionInner.addClass("expanded");
        });

        $(window).on("breakpoint:change", function () {
            initReadMoreDesc();
        });
    },

    toggleShippingInfo: function () {
        $("body").on("click", ".shipping-info-trigger", function (e) {
            e.preventDefault();

            var headerHeight = $(".header-wrapper").outerHeight();
            var $shippingInfoHeading;
            var $shippingInfoBody;
            var shippingInfoTopOffset;

            if (!commonFeature.isBreakpoint(">=md")) {
                $shippingInfoHeading = $(".sidebar-section").find(".delivery-information .card-header > button");
                $shippingInfoBody = $(".sidebar-section").find(".delivery-information .collapse");
                headerHeight = 0;
            } else {
                $shippingInfoHeading = $(".carousel-section").find(".delivery-information .card-header > button");
                $shippingInfoBody = $(".carousel-section").find(".delivery-information .collapse");
            }
            shippingInfoTopOffset = $shippingInfoHeading.offset().top;

            $("html, body").animate({
                "scrollTop": shippingInfoTopOffset - headerHeight
            }, 300);

            if (!$shippingInfoBody.hasClass("show")) {
                $shippingInfoBody.collapse("show");
            }
        });
    },

    toggleSpecifications: function () {
        $("body").on("click", ".specifications-toggler", function (e) {
            e.preventDefault();

            var isDesktop = $(this).closest(".carousel-section").length;
            var headerHeight = $(".header-wrapper").outerHeight();
            var $specificationsHeading;
            var $specificationsBody;
            var specsTopOffset;

            if (isDesktop) {
                $specificationsHeading = $(".carousel-section").find(".product-attributes .card-header > button");
                $specificationsBody = $(".carousel-section").find(".product-attributes .collapse");
            } else {
                $specificationsHeading = $(".sidebar-section").find(".product-attributes .card-header > button");
                $specificationsBody = $(".sidebar-section").find(".product-attributes .collapse");
                headerHeight = 0;
            }
            specsTopOffset = $specificationsHeading.offset().top;

            $("html, body").animate({
                "scrollTop": specsTopOffset - headerHeight
            }, 300);

            if (!$specificationsBody.hasClass("show")) {
                $specificationsBody.collapse("show");
            }
        });
    },

    handleStickyBuyBar: function () {
        handleStickyBuyBar();

        $window.on("windowscroll", debounce(handleStickyBuyBar, 50));

        $window.on("windowresize:width", debounce(handleStickyBuyBar, 50));

        $(".pdp-customizer-container").on("click", ".cz__group-header", function () {
            setTimeout(handleStickyBuyBar, 500);
        });
    },

    prepareForPrint: function () {
        $(document).on("click", ".print-icon", function () {
            if ($(".cz__group-header").length > 0) {
                $("body").trigger("product:drivePrint");
            } else {
                window.print();
            }
        });
    },

    handleStickyDetails: function () {
        $("body").on("product:afterAttributeSelect", function () {
            setTimeout(handleStickyDetailsHeight, 500);
        });

        $(document).on("click", ".cz__tab, .variations-toggler[data-toggle='collapse'], .cz__group-header, .description-and-detail.accordion .product-attributes, .description-and-detail.accordion .delivery-information, .description-and-detail.accordion .care-instruction", function () {
            setTimeout(handleStickyDetailsHeight, 500);
        });

        $window.on("windowresize:width", handleStickyDetailsHeight);

        handlePDPImagesResize();
    },

    initReadMoreDesc: initReadMoreDesc(),

    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),

    initPDPSliders: slickCarousel.initPDPSliders(),

    initZoomModal: initZoomModal(),

    editCartItem: base.editCartItem
};
